import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { NgClass, NgForOf, NgIf, NgSwitch, NgSwitchCase, TitleCasePipe } from '@angular/common';
import { MatDatepicker, MatDatepickerInput } from '@angular/material/datepicker';
import { ButtonDetails, ButtonSolidComponent } from '../button-solid/button-solid.component';
import { InputDetails } from '../../../core';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    NgClass,
    NgForOf,
    FormsModule,
    NgSwitch,
    NgSwitchCase,
    NgIf,
    TitleCasePipe,
    MatDatepicker,
    ButtonSolidComponent,
    MatDatepickerInput,
  ],
})
export class FormComponent implements OnInit {
  @Input() formFields!: InputDetails[];
  @Input() buttonDetails!: ButtonDetails;
  @Output() form = new EventEmitter<NgForm>();

  private passwordFieldChanged!: boolean;
  private file: any;

  constructor() {}

  ngOnInit(): void {}

  submitForm(form: NgForm): void {
    if (this.file) {
      this.formFields.filter((field) => {
        if (field.type === 'file') {
          form.value[field.name] = this.file;
          field.text = 'Upload File';
        }
      });
    }
    this.form.emit(form);
    this.buttonDetails.disabled = true;
  }

  inputGroupAction(field: InputDetails): void {
    switch (field.type) {
      case 'password':
        this.changePasswordInput(field);
        break;
      case 'text':
        this.changeTextInput(field);
        break;
      default:
        break;
    }
  }

  changePasswordInput(field: InputDetails): void {
    field.type = 'text';
    field.inputGroupText = 'hide';
    this.passwordFieldChanged = true;
  }

  changeTextInput(field: InputDetails): void {
    if (this.passwordFieldChanged) {
      field.type = 'password';
      field.inputGroupText = 'show';
      this.passwordFieldChanged = false;
    }
  }

  handleUpload(target: any): void {
    this.file = target.files[0];
    this.formFields.filter((field) => {
      if (field.type === 'file') {
        field.text = this.file.name;
      }
    });
  }
}
